import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../../Config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import { Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import { truncateText, capitalizeFirstLetter } from "../../../helpers";
import { FaFemale, FaMale } from "react-icons/fa";
import { BiMaleFemale } from "react-icons/bi";
import NotFoundModel from "../../NotFoundModel";
import { MdOutlineChevronRight } from "react-icons/md";
import CustomTooltip from "../../Tooltip"


const Table = ({
  apiData,
  setSelectedData,
  selectedData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const storageKey = `vacant_active_page`;
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;

  const [selectedRow, setSelectedRow] = useState(null);
  const [previousId, setPreviousId] = useState(null);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(savedPage);

  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const CustomSelect = styled(Select)({
    "& .MuiSelect-icon": {
      color: "#f59e0b",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    zIndex: 0,
  });

  const ActionBtns = (item) => {

    return (
      <div className="flex gap-4 ">
        {item.status !== 4 && (
          <button
            title="Manage Inventory"
            onClick={() => {
              navigate('/inventory', { state: { propertyDetails: item } });

            }}
            className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
          >

            <MdOutlineChevronRight size={24} color="#BDBDBD" />
          </button>)}
      </div>
    );
  };
  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        address: item?.address ? getAddress(item) : 'N/A',
        sharing: sharingBreakupCell(item),
        occupancy: occupancyCell(item),
        action: ActionBtns(item),
        beds: bedCount(item),
        //totalCollection: <Amount>{'₹' + item.totalCollection}</Amount>
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  const getAddress = (item) => {
    return (
      <div className='text-sm text-gray-600'>
        <div className="flex">
          <span
            data-tooltip-id={`tooltip-${item.id}`}
            data-tooltip-content={item.address}
            data-tooltip-delay-show={500}
            data-tooltip-place="top"
            data-tooltip-variant="info"
            className="text-gray-600 text-sm"
          >
            {capitalizeFirstLetter(truncateText(item.address, 25))}
          </span>
        </div>
        <Tooltip id={`tooltip-${item.id}`} className="max-w-[70%] md:max-w-[50%] xl:max-w-[40%] 2xl:max-w-[20%]" />
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return (
      <UserImageWrapper>
        {item.tenantPreference === 1 ? (
          <FaMale className="text-gray-400 w-8 h-8" />
        ) : item.tenantPreference === 2 ? (
          <FaFemale className="text-gray-400 w-8 h-8" />
        ) : <BiMaleFemale className="text-gray-400 w-8 h-8" />}
        <div className="flex flex-col">
          <div className="flex">
            <span className="text-gray-600 text-sm font-medium" data-tooltip-id={`tooltip-${item.id}`}
              data-tooltip-content={item.name}
              data-tooltip-delay-show={500}
              data-tooltip-place="top"
              data-tooltip-variant="info">
              {capitalizeFirstLetter(truncateText(item.name, 25))}
            </span>
          </div>
          <span className="text-gray-400 text-xs">
            {/* #{item.type === 1 ? "PG" : item.type === 2 ? "Flat" : ""} */}
            #{item?.gId ? item?.gId : item?.id}
          </span>
          <Tooltip id={`tooltip-${item.id}`} className="max-w-[70%] md:max-w-[50%] xl:max-w-[40%] 2xl:max-w-[20%]" />
        </div>
      </UserImageWrapper>
    );
  };

  const sharingBreakupCell = (item) => {
    return (
      <div className="flex flex-wrap gap-1">
        {item.singleSharing > 0 && (
          <CustomTooltip label={'Single Sharing'}>
            <span className="bg-blue-50 text-blue-600 px-2 py-1 rounded text-xs">
              S: {item.singleSharing}
            </span>
          </CustomTooltip>
        )}

        {item.doubleSharing > 0 && (
          <CustomTooltip label={'Double Sharing'}>
            <span className="bg-green-50 text-green-600 px-2 py-1 rounded text-xs">
              D: {item.doubleSharing}
            </span>
          </CustomTooltip>
        )}

        {item.tripleSharing > 0 && (
          <CustomTooltip label={'Triple Sharing'}>
            <span className="bg-yellow-50 text-yellow-700 px-2 py-1 rounded text-xs">
              T: {item.tripleSharing}
            </span>
          </CustomTooltip>
        )}

        {item.threePlusSharing > 0 && (
          <CustomTooltip label={'3+ Sharing'}>
            <span className="bg-purple-50 text-purple-600 px-2 py-1 rounded text-xs">
              3+: {item.threePlusSharing}
            </span>
          </CustomTooltip>
        )}
      </div>
    );
  };

  const occupancyCell = (item) => {
    const pct = item.occupancyPercentage || 0;

    const color =
      pct >= 80
        ? "bg-green-100 text-green-700"
        : pct >= 50
          ? "bg-yellow-100 text-yellow-700"
          : "bg-red-100 text-red-700";

    return (
      <span
        className={`px-3 py-1 rounded-full text-xs font-semibold ${color}`}
      >
        {pct}%
      </span>
    );
  };

  const bedCount = (item) => {
    return (
      <div className="flex">
        <span className="text-gray-600 text-sm bg-rose-100 px-3 py-1 rounded-md inline-flex">
          {item.vacantBeds + " beds"}
        </span>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Property Details",
          accessor: "name",
        },
        {
          Header: "Status",
          accessor: "status",
        },
      ];
    }
    return [
      {
        Header: "Property",
        accessor: "name",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Vacancies",
        accessor: "beds",
      },
      {
        Header: "Sharing",
        accessor: "sharing",
      },
      {
        Header: "Occupancy",
        accessor: "occupancy",
      },
      // {
      //     Header: "Collection",
      //     accessor: "totalCollection",
      // },
      // {
      //   Header: "Status",
      //   accessor: "status",
      // },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setCurrentPage(pageIndex);
  // }, [pageIndex]);
  useEffect(() => {
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={column.style}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={cell.column.style}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Address:</strong> {data[rowIndex].address}
                        </li>
                        <li>
                          <strong>Occupied/Vacant Beds:</strong> {data[rowIndex].beds}
                        </li>
                        <li>
                          <strong>Collection:</strong> {data[rowIndex].totalCollection}
                        </li>
                        <li>
                          <strong>Action</strong>{" "}
                          {data[rowIndex].action}
                        </li>


                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {apiData?.length === 0 && <NotFoundModel />}
    </>
  );
};

const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItemCustom = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const Active = tw.div`bg-green-50 text-green-500 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Pending = tw.div`cursor-pointer bg-blue-50 text-blue-500 text-xs border-blue-300 border w-40  h-7 flex items-center justify-center rounded-lg cursor-pointer`;
const Completed = tw.div`bg-lime-50 text-lime-500 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded-lg cursor-pointer`;
const Inactive = tw.div`bg-red-50 text-red-500 text-xs border-red-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const PG = tw.div``;
const Flat = tw.div``;
const Amount = tw.p`text-gray-600 text-sm flex`
export default Table;
